import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, split } from '@apollo/client/core';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { Kind, OperationTypeNode } from 'graphql';
import { environment } from '../../environments/environment';

export const createApolloConfig = () => {
  const oAuthService = inject(OAuthService);
  const httpLink = inject(HttpLink);

  // Create an http link:
  const http = httpLink.create({
    uri: environment.graphqlUrl,
  });

  // Create a WebSocket link:
  const apolloWsLink = new GraphQLWsLink(
    createClient({
      url: environment.graphqlWsUrl,
      connectionParams: () => ({
        Authorization: `Bearer ${oAuthService.getAccessToken()}`,
      }),
    })
  );

  // Using the ability to split links, you can send data to each link
  // depending on what kind of operation is being sent
  const link = split(
    // Split based on operation type
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === Kind.OPERATION_DEFINITION &&
        definition.operation === OperationTypeNode.SUBSCRIPTION
      );
    },
    apolloWsLink,
    http
  );

  return {
    link,
    cache: new InMemoryCache(),
  };
};
